import { useEffect } from 'react';
import { useAppDispatch } from './redux';
import { setNetworkStatus } from '@/store/slices/appSlice';

// 监听网络状态的hook
export const useNetworkStatus = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const updateNetworkStatus = () => {
      dispatch(setNetworkStatus(navigator.onLine ? 'online' : 'offline'));
    };

    // 初始状态
    updateNetworkStatus();

    // 监听网络状态变化
    window.addEventListener('online', updateNetworkStatus);
    window.addEventListener('offline', updateNetworkStatus);

    return () => {
      window.removeEventListener('online', updateNetworkStatus);
      window.removeEventListener('offline', updateNetworkStatus);
    };
  }, [dispatch]);
};